import { Assert } from "@seriously-rad/seriouslyrad-framework-core/Assert";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { StringHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/StringHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { ButtonStyleEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ButtonStyleEnum";
import { Dialog, DialogPropertyValues, IDialog } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/Dialog";
import { PropertyEditorDocumentTemplate } from "../Controls/PropertyEditorDocumentTemplate";
import { NAMESPACE } from "./_Namespace";

export type CreateDocumentDialogPropertyValues =
    DialogPropertyValues
    & {
    };

export type CreateDocumentDialogProperties = {
    [name in keyof CreateDocumentDialogPropertyValues]: Property<CreateDocumentDialogPropertyValues[name]>
};

export interface ICreateDocumentDialog extends IDialog, CreateDocumentDialogProperties
{
}

export class CreateDocumentDialog extends Dialog implements ICreateDocumentDialog
{
    // #region Static

    public static override classNamespace = NAMESPACE + "CreateDocumentDialog";
    public static override className = "CreateDocumentDialog";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<CreateDocumentDialogPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                buttonStyle: ButtonStyleEnum.okCancel,
                okButtonText: "Create",
                title: "Create Document",
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    public propertyEditorCombo?: PropertyEditorDocumentTemplate;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<CreateDocumentDialogPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _createElement()
    {
        const
            $$element = super._createElement();

        this.propertyEditorCombo =
            new PropertyEditorDocumentTemplate({
                editMode: true,
                mandatory: true
            })
                .appendTo(this);

        return $$element;
    }
    protected override _createElementComplete()
    {
        super._createElementComplete();

        this.addCssClass("rad-control-barcode-dialog-create-document");
    }
    public override async openAsync(entityName: string)
    {
        Assert.isNotNullOrUndefined(this.propertyEditorCombo, "this.propertyEditorCombo");
        this.propertyEditorCombo.primaryEntityFilter.set(`entity/name eq '${(entityName || StringHelper.empty).replace(/'/gi, "''")}'`);
        await this.propertyEditorCombo.loadDataAsync();
        return await super.openAsync();
    }

    // #endregion

    // #endregion
}

